module.exports = __webpack_public_path__ + "static/media/Total_Assets_Labeled.5801cf02.svg";